import Title from "segments/desktop/core-components/title/title";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";
import { StyledProductCardContent } from "./product-card-content.scss";
import ProductCardUseCases from "./product-card-use-cases/product-card-use-cases";

const ProductCardContent = ({
  title,
  body,
  titleWidth,
  useCasesWidth,
  useCases,
  textWidth,
  productColor,
  isUseCasesReadonly,
  productType,
  showUseCasesVertically,
  spaceUnderTitle
}) => (
  <StyledProductCardContent className="product-card-content">
    <div className="title-container" style={{ marginBottom: spaceUnderTitle, maxWidth: titleWidth }}>
      <Title title={title} titleClassName="content-title" />
    </div>
    <div className="use-cases-wrapper" style={{ maxWidth: useCasesWidth }}>
      <Paragraph textWidth={textWidth} body={body} />
      <ProductCardUseCases
        productColor={productColor}
        productType={productType}
        useCases={useCases}
        isUseCasesReadonly={isUseCasesReadonly}
        showUseCasesVertically={showUseCasesVertically}
      />
    </div>
  </StyledProductCardContent>
);

export default ProductCardContent;
